module.exports = __webpack_public_path__ + "static/media/Men.9a730a4f.svg";